import React, { useState, useEffect} from 'react';
import { useHistory } from "react-router-dom";
import { useClient } from '../../../../hooks/useClient';
import { useOffice } from '../../../../hooks/useOffice';
import { useCash } from '../../../../hooks/useCash';
import Spinner from '../../../../components/Spinner';
import SearchFilters from '../../../../components/SearchFilters';
import Swal from 'sweetalert2';
import NotifyC from '../../../../components/Notifications';
import { getRolName } from '../../../../utils/Common';
import { FaPlus, FaUserCircle } from 'react-icons/fa';
import { IoFilter } from 'react-icons/io5';
import ClientDetails from '../../../../components/ui/ClientDetails';
import './index.css';

const Clients = () => {
  const { getClients, getDetailClients, getClientRoles , updateClient } = useClient();
  const { getPostOfficesList, managePostOffice, getListProvinces } = useOffice();
  const { getCashBoxesList, manageCashBoxes } = useCash();
  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [openSearch, setOpenSearch] = useState(false);
  const [configFilter, setConfigFilter] = useState({ totalItems: 0, totalPages: 1, itemsPerPage: 20, currentPage: 1 });
  const [selectedClient, setSelectedClient] = useState(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [officeList, setOfficeList] = useState([]);
  const [cashList, setCashList] = useState([]);
  const [provinceList, setProvinceList] = useState([]);
  const [provinceSelected, setProvinceSelected] = useState(null);
  const [roles, setRoles] = useState([]);
  const history = useHistory();

  const parametersSearch = [
    { id: "NombreSimple", label: "Nombre" },
    { id: "ApellidoSimple", label: "Apellido" },
    { id: "email", label: "Email" },
    { id: "roleId", label: "Rol" },
    { id: "phone", label: "Teléfono" },
  ];

  const showConfirmDialog = async (title, html) => {
    return await Swal.fire({
      icon: "question",
      title: title,
      html: html,
      showCancelButton: true,
      confirmButtonColor: "white",
      cancelButtonColor: "black",
      confirmButtonText: "Si",
      cancelButtonText: "No",
      customClass: {
        confirmButton: 'custom-confirm-button',
        cancelButton: 'custom-cancel-button',
      }
    });
  };

  const handleErrorResponse = (response) => {
    if (response.code === 400) {
      switch (response.message) {
        case 'INVALID_ACTION':
          NotifyC.error('Acción no válida');
          break;
        case 'CLIENT_HAS_ASSIGNED_CASHBOXES':
          NotifyC.error('Usuario tiene cajas asignadas');
          break;
        case "CASHBOXES_NOT_FOUND":
          NotifyC.error('No se encontraron cajas por asignar para usuario');
          break;
        case 'ONE_OR_MORE_CASHBOXES_ALREADY_ASSIGNED_TO_CLIENT':
          NotifyC.error('Una o más cajas ya están asignadas al usuario');
          break;
        case 'ONE_OR_MORE_OFFICES_ALREADY_ASSIGNED_TO_CLIENT':
          NotifyC.error('Una o más estafetas ya están asignadas al usuario');
          break;
        case 'CLIENT_ROLE_CANNOT_HAVE_CASHBOX_ASSIGNED': 
          NotifyC.error('Usuario no puede tener cajas asignadas');
          break;
        case 'CLIENT_ROLE_CANNOT_HAVE_OFFICES_ASSIGNED':
          NotifyC.error('Usuario no puede tener estafetas asignadas');
          break;
        case 'CLIENT_NOT_FOUND':
          NotifyC.error('Usuario no encontrado');
          break;
        case 'CLIENT_ALREADY_DEACTIVATED':
          NotifyC.error('Usuario ya está desactivado');
          break;
        case 'CLIENT_ALREADY_ACTIVATED':
          NotifyC.error('Usuario ya está activado');
          break;
        default:
          NotifyC.error('Error al realizar acción');
          break;
      }
    }
  };

  const handleGetClients = async () => {
    const abortController = new AbortController();
    try {
      const response = await getClients(abortController.signal);
      if (response.length > 0) {
      setClients(response);
      setFilteredClients(response);
      setConfigFilter((prev) => ({
        ...prev,
        totalItems: response.length,
        totalPages: Math.ceil(response.length / prev.itemsPerPage),
      }));
      } else {
        NotifyC.error('No se encontraron usuarios');
      }
    } catch (error) {
      NotifyC.error('Error al obtener la lista de usuarios');
    } finally {
      setIsLoading(false);
    }
  };
 
const handleOnUpdateClient  = async (client, roleId, idType) => {
  try {
    const abortController = new AbortController();

    const dataToSend = { 
      Accion: 1,
      IdCliente: client.IdCliente, 
      Nombre: client.NombreSimple, 
      Apellido: client.ApellidoSimple,
      Email: client.Email,   
      IdRoleBli: roleId ?? null,
      Usuario: client.Usuario, 
      tipoDocumento: idType,
      numDocumento: client.NumDocumento,
    };

    const response = await updateClient(abortController.signal, dataToSend);
    if (response.code === 200) {

      NotifyC.success("usuario actualizado correctamente");
      const updatedClient = {...selectedClient, ...client, roleId: roleId ?? client.roleId};
      setSelectedClient(updatedClient);
      setClients((prev) => 
        prev.map((c) => 
          (c.IdCliente === updatedClient.IdCliente ? updatedClient : c)
      ));
    } else {
      handleErrorResponse(response);
    }
    return response;
  } catch (error) {
    NotifyC.error('Error al actualizar usuario');
  }
};

  const handleGetOfficeByProvince = async () => {
    const abortController = new AbortController();
    try {
        const response = await getListProvinces(abortController.signal);
        if (response.length > 0) {
            setProvinceList(response);
        } else {
            setProvinceList([]);
            NotifyC.error('No se encontraron estafetas por asignar en la provincia seleccionada al usuario');
        }
    } catch (error) {
        NotifyC.error('Error al obtener la lista de provincias');
    }
};

  const handleGetOfficeForClient = async (client, provinceSelected) => {
  
    const abortController = new AbortController();
    try {
      const dataToSend = { IdCliente: client.IdCliente, IdProvincia: provinceSelected };
      const response = await getPostOfficesList(abortController.signal, dataToSend);

      if (response.length > 0) {
        setOfficeList(response);
      } else {
        NotifyC.error('No se encontraron estafetas por asignar para usuario');
      }
    } catch (error) {
      NotifyC.error('Error al obtener la lista de estafetas');
    }
  };

  const handleGetCashBoxesList = async (client, officeId) => {
    setCashList([]);
    const abortController = new AbortController();
    try {
      const dataToSend = { IdCliente: client.IdCliente, IdEstafeta: officeId };
      const response = await getCashBoxesList(abortController.signal, dataToSend);
    
      if (response.length > 0) {
      setCashList(response);
      }else {
        setCashList([]);
        NotifyC.error('No se encontraron cajas por asignar para usuario');
      }
    } catch (error) {
      NotifyC.error('Error al obtener la lista de cajas');
    }
  };

  const handleGetRoles = async () => {
    const abortController = new AbortController();
    try {
      const response = await getClientRoles(abortController.signal);
      if (response.length > 0) {
        const responseFiltered = response.filter((item) => item.value !== 0 && item.value !== 9);
        setRoles(responseFiltered);
      } else {
        NotifyC.error('No se encontraron roles para asignar a usuarios');
      }
    } catch (error) {
      NotifyC.error('Error al obtener roles');
    }
  };

  useEffect(() => {
    let filtered = clients;
    selectedFilters.forEach((filter) => {
      if (filter.id === "roleId") {
        const role = roles.find((r) =>
          r.label.toLowerCase().includes(filter.searchTerm.toLowerCase())
        );
        if (role) {
          filtered = filtered.filter((client) => client.roleId === role.value);
        }
      } else {
        filtered = filtered.filter((client) =>
          client[filter.id]?.toString().toLowerCase().includes(filter.searchTerm.toLowerCase())
        );
      }
    });
  
    setFilteredClients(filtered);
    setConfigFilter((prev) => ({
      ...prev,
      totalItems: filtered.length,
      totalPages: Math.ceil(filtered.length / prev.itemsPerPage),
      currentPage: 1,
    }));
  }, [selectedFilters, clients, roles]);

  const goToPage = (page) => {
    setConfigFilter((prev) => ({ ...prev, currentPage: page }));
  };

  const indexOfLastClient = configFilter.currentPage * configFilter.itemsPerPage;
  const indexOfFirstClient = indexOfLastClient - configFilter.itemsPerPage;
  const currentClients = filteredClients.slice(indexOfFirstClient, indexOfLastClient);

  const handleResetFilters = () => {
    setSelectedFilters([]);
    handleViewSearch();
  };

  const handleViewSearch = () => {
    setOpenSearch(!openSearch);
  };

  useEffect(() => {
    handleGetClients();
  }, []);

  useEffect(() => {
    handleGetRoles();
  }, []);

  useEffect(() => {
    handleGetOfficeByProvince();
    if (selectedClient && provinceSelected) {
      handleGetOfficeForClient(selectedClient, provinceSelected);
    }
  }, [selectedClient, provinceSelected]);

  const handleClientClick = async (client) => {
    setIsLoadingDetails(true);
    try {
      const abortController = new AbortController();
      const dataToSend = { IdCliente: client.IdCliente };
      const detailsClient = await getDetailClients(abortController.signal, dataToSend);

      setSelectedClient({ ...client, sucursales: Array.isArray(detailsClient) ? detailsClient : [] });
    } catch (error) {
      NotifyC.error('Error al obtener detalles del usuario');
      setSelectedClient({ 
        ...client, 
        sucursales: [] 
      });
    } finally {
      setIsLoadingDetails(false);
    }
  };

  const handleCloseDetails = () => {
    setSelectedClient(null);
  };


  const handleStatusClient = async (client, newStatus) => {
      const status = newStatus === true ? 'activar' : 'desactivar';
      const confirm = await showConfirmDialog(`Deseas ${status} al usuario?`, '');
      if (!confirm.isConfirmed) {
        return;
      }
      try {
        const abortController = new AbortController();
        const dataToSend = { 
          Accion: newStatus === true ? 3: 2,
          IdCliente: client.IdCliente, 
        };
        const response = await updateClient(abortController.signal, dataToSend);

        if (response.code === 200) {
          Swal.fire({
            icon: 'success',
            title: 'usuario actualizado correctamente',
            html: `El usuario ha sido ${newStatus === true ? 'activado' : 'desactivado'} correctamente`,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "custom-confirm-button",
            },
          });

          const updatedClient = { ...selectedClient, ...client, IdEstatus: newStatus };
          setSelectedClient(updatedClient);
          setClients((prev) =>
            prev.map((c) => (c.IdCliente === updatedClient.IdCliente ? updatedClient : c))
          );
          handleGetClients();
        } else {
          handleErrorResponse(response);
        }
        return response;
      } catch (error) {
        NotifyC.error('Error al cambiar estado de usuario');
      }
    };

  const handleManagePostOffice = async (data) => {
    const confirm = await showConfirmDialog(`Deseas ${data.Accion === 1 ? 'asignar' : 'remover'} ${data.IdPostOffice.length > 1 ? 'las estafetas' : 'la estafeta'}?`, 
      '');

    if (!confirm.isConfirmed) {return;}
    try {
      const abortController = new AbortController();
      const response = await managePostOffice(abortController.signal, data);
      if (response.code === 200) {
      NotifyC.success(`` + (data.Accion === 1 ? 'Estafeta asignada' : 'Estafeta removida') + ` correctamente`);
      } else {
        handleErrorResponse(response);
      }
      return response.payload; 
    } catch (error) {
      NotifyC.error('Error al realizar acción de estafeta');
    }
  };

  const handleManageCashBoxes = async (data) => {

    const confirm = await showConfirmDialog(`Deseas ${data.Accion === 1 ? 'asignar' : 'remover'} ${data.IdCaja.length > 1 ? 'las cajas' : 'la caja'}?`,
      '');

    if (!confirm.isConfirmed) {
      return;
    }
    try {
      const abortController = new AbortController();
      const response = await manageCashBoxes(abortController.signal, data);

      if (response.code === 200) {
        NotifyC.success(`` + (data.Accion === 1 ? 'Caja asignada' : 'Caja removida') + ` correctamente`);
      } else {
        handleErrorResponse(response);
      }
      return response.payload;
    } catch (error) {
      NotifyC.error('Error al realizar acción de caja');
    }
  };

  const LoadingSpinner = ({type}) => {
    switch (type) {
      case 1:
        return (
          <div
            style={{
              position: "absolute",
              top: 0,
              padding: 20,
              right: 0,
              left: 0,
              backgroundColor: "rgb(0 0 0 / 81%)",
              height: "100vh",
              zIndex: 1000,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "black",
            }}
            className="text-left"
          >
            <Spinner type={1} size={40} color="white" />
          </div>
        );
      case 2:
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Spinner type={2} size={40} color="black" />
          </div>
        );
      default:
        return null;
    }
  };
 
  return (
    <>
      {isLoadingDetails ? (
        <LoadingSpinner type={2}/>
      ) : selectedClient ? (
        <ClientDetails
          client={selectedClient}
          onClose={handleCloseDetails}
          onUpdateClient={handleOnUpdateClient}
          onStatusClient={handleStatusClient}
          onCashBoxes={handleGetCashBoxesList}
          onManagePostOffice={handleManagePostOffice}
          onManageCashBoxes={handleManageCashBoxes}
          isActive={selectedClient.IdEstatus === 1 ? true : false}
          officeList={officeList}
          setOfficeList={setOfficeList}
          cashList={cashList}
          rolesList={roles} 
          provinceList={provinceList}
          provinceSelected={provinceSelected}
          setProvinceSelected={setProvinceSelected}
        />
      ) : (
        <>
          <div className="dashboardCard text-left" style={{ color: "black" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
              <div className="d-flex align-items-center" style={{ gap: "15px", flex: "1" }}>
                <h5 className="mb-0">Usuarios</h5>
              </div>
              <button className="btn btn-warning mr-2" style={{ color: "black" }} onClick={() => history.push("/dashboard/administration/create/user")}>
                <FaPlus /> Crear Usuarios
              </button>
              <div className="d-flex align-items-center" style={{ gap: "15px", flex: "0" }}>
                <div className="d-flex">
                  <button className="btn btn-white d-flex align-items-center" onClick={() => handleViewSearch()}>
                    {selectedFilters.length > 0 && (
                      <span className="badge mr-1" style={{ background: "#424996", color: "white" }}>
                        {selectedFilters.length}
                      </span>
                    )}
                    <span>Filtros</span>
                    <IoFilter className="ml-2" />
                  </button>
                  {openSearch && (
                    <div style={{ position: "absolute", right: "15px", top: "110px", background: "#fff", padding: "25px", boxShadow: "0px 0px 10px rgba(92, 92, 92, 0.211)", borderRadius: "16px", zIndex: 99 }}>
                      <button
                        type="button"
                        className="btn btn-sm"
                        style={{ position: "absolute", top: "-5px", right: "0", color: "white", background: "gray", padding: "0 5px", borderRadius: "50px" }}
                        onClick={() => handleViewSearch()}
                      >
                        &times;
                      </button>
                      <SearchFilters
                        parameters={parametersSearch}
                        selectedFilters={selectedFilters}
                        setSelectedFilters={setSelectedFilters}
                        handleResetFilters={handleResetFilters}
                      />
                    </div>
                  )}
                </div>
                <div className="d-flex align-items-center ml-2">
                  <button
                    className="btn btn-white mr-2"
                    onClick={() => goToPage(configFilter.currentPage - 1)}
                    disabled={configFilter.currentPage === 1}
                  >
                    {"<"}
                  </button>
                  <div className="d-flex align-items-center">
                    <span>{configFilter.currentPage}</span>
                    <span className="mx-1">de</span>
                    <span>{configFilter.totalPages}</span>
                  </div>
                  <button
                    className="btn btn-white ml-2"
                    onClick={() => goToPage(configFilter.currentPage + 1)}
                    disabled={configFilter.currentPage === configFilter.totalPages}
                  >
                    {">"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {!isLoading ? (
            <div className="dashboardCard">
              <div className="container-clients">
                <div className="clients-list">
                  {currentClients.length > 0 ? (
                    currentClients.map((client, index) => (
                      <div key={client.id || `client-${index}`} className="client-card" onClick={() => handleClientClick(client)} style={{ position: 'relative' }}>
                        {/* Etiqueta de ID tipo hoja en la esquina superior derecha */}
                        <div className="client-id-sticker">
                          #{client.IdCliente}
                        </div>
                        <div className="client-card-content">
                          <div className="client-icon-container">
                            <FaUserCircle className="client-icon" />
                          </div>
                          <div className="client-info">
                            <h3 className="client-name">{client.NombreSimple} {client.ApellidoSimple}</h3>
                            <div className="client-details">
                              <div className="detail-item">
                                <span className="detail-label">Usuario:</span>
                                <span className="detail-value">{client.Usuario}</span>
                              </div>
                              <div className="detail-item">
                                <span className="detail-label">Rol:</span>
                                <span className="detail-value">{getRolName(client.roleId)}</span>
                              </div>
                              <div className="detail-item">
                                <span className="detail-label">Email:</span>
                                {client.Email === '' ? 'No asignado' : client.Email}
                              </div>
                              <div className="detail-item">
                                <span className="detail-label">Estado:</span>
                                <span className={`client-status ${client.IdEstatus === 1 ? 'active' : 'inactive'}`}>
                                  {client.IdEstatus === 1 ? 'Activo' : 'Inactivo'}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <Spinner type={1} size={40} color="black" />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <LoadingSpinner type={1}/>
          )}
        </>
      )}
    </>
  );
};

export default Clients;